export interface IConfigurations {
  id?: string;
  configKey?: string;
  value?: string;
  ecoleId?: string | null;
}

export const defaultValue: Readonly<IConfigurations> = {
  id: null,
  configKey: '',
  value: '',
  ecoleId: null,
};
